// src/pages/Documentos/EditarDocumento.js
import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarContrato from "./CadastrarContratos";

const EditarContrato = () => {
    const { id } = useParams();

    return <CadastrarContrato contratoId={id} />;
};

export default EditarContrato;
